import React from 'react';

type Props = {
  style: React.CSSProperties;
  message: string;
};

const DownloadPanelTooltip = ({ style = {}, message = '' }: Props) => {
  return (
    <span style={style} className="iris_tooltip">
      {message}
    </span>
  );
};

export default DownloadPanelTooltip;
